/** Business-dialect overrides. Sparse: a missing key falls back to en. feesSection is deliberately absent - business suppresses the heading via practice config, so the base string never renders. */
export const invoice = {
    totals: {
        feesVat: 'VAT on services',
        disbursementsVat: 'VAT on expenses',
        feesAfterDiscount: 'Services after discount',
        feesAfterAdjustment: 'Services after adjustment',
        disbursementsAfterDiscount: 'Expenses after discount',
        disbursementsAfterAdjustment: 'Expenses after adjustment',
    },
    pdf: {
        projectReference: 'Project',
        disbursementsSection: 'Expenses',
        feesSubtotal: 'Services subtotal',
        disbursementsSubtotal: 'Expenses subtotal',
    },
    editor: {
        feeLineType: 'Service',
        disbursementLineType: 'Expense',
        projectCardLabel: 'Project',
        noProjectName: 'Add a project name',
        projectNamePlaceholder: 'Add project name',
        clearProjectAriaLabel: 'Clear project',
        projectRowHint: 'Leave blank to hide the project row on the invoice PDF.',
        projectUpdateError: 'Could not update project name.',
        projectNameTooLong: 'Project name must be 200 characters or less',
        projectFieldLabel: 'Project name',
        matter: {
            noMatterDirectOnly: 'No project – direct charges only',
            noMatter: 'No project',
            chooseClientAndMatter: 'Choose client and project',
            chooseMatter: 'Choose a project',
            nameUnavailable: "Couldn't load the project name",
            changeAriaLabel: 'Change project or name on invoice',
            switchAction: 'Switch project',
            matterLine: 'Project: {{name}}',
            stepTitle: 'New project for this invoice',
            searchAriaLabel: 'Search projects',
            searchPlaceholder: 'Search projects...',
            listAriaLabel: 'Projects',
            sameNameHint: 'Same name as the current project',
            loadError: "Couldn't load projects. Try searching again.",
            noSearchMatches: 'No projects match “{{query}}”.',
            noMattersInCurrency: '{{client}} has no projects billed in {{currency}}.',
            noMattersInCurrencyYet: 'None of the projects loaded so far are billed in {{currency}}. Load more to keep looking.',
            createAction: 'Create a new project',
            newNameLabel: 'Project name',
            newNameRequired: 'Enter a project name',
            createAndUse: 'Create and use project',
            moveNote_one: 'The {{count}} entry on this invoice moves to the project you choose for {{client}}.',
            moveNote_other: 'The {{count}} entries on this invoice move to the project you choose for {{client}}.',
            confirmRemove: 'Remove and change project',
            confirmTitle: 'Change project',
            changeFailed: "Couldn't change the project. Try again.",
            setFailed: "Couldn't set the project. Try again.",
        },
        switchClientClearsProject: "Changing client clears the invoice’s project name and reference.",
        fromDetailsConfirm: {
            title: 'Change your business details',
            message: "This changes your own business details, not your client's. Your drafts and every invoice you approve from now on will use them, and invoices already issued keep their current details. Save the changes?",
            confirmLabel: 'Save business details',
        },
        feesSectionHeading: 'Services',
        disbursementsSectionHeading: 'Expenses',
        omnibox: {
            closedHint: 'Start typing to search activities or expenses, or to create a new line',
            searchPlaceholder: 'Search activities or expenses, or type to create a line…',
            emptyHint: 'Start typing to search unbilled activities or approved expenses.',
            noMatches: 'No matching activities or expenses found.',
            clientlessEmptyHint: 'Type a description to add a direct charge. Choose a client to add recorded work or expenses.',
            clientlessNoMatches: 'Choose a client to add recorded work or expenses.',
            expenseLaneAriaLabel: 'Approved expenses',
            otherMatterMatches_one: '{{count}} more match on {{matter}}. An invoice covers one project.',
            otherMatterMatches_other: '{{count}} more matches on {{matter}}. An invoice covers one project.',
            noMatterEmptyHint: 'Type a description to add a direct charge. Choose a project to add activities and expenses.',
            noMatterNoMatches: 'Choose a project to add activities and expenses.',
        },
        expenseAlreadyBilled: {
            title: 'Expense already billed',
            description: 'This expense is already on a line item on this or another invoice.',
        },
    },
    approveWarning: {
        clientLevel: {
            description: "It has no project, so it will show on the client's statement but on no project's statement.",
        },
        matterArchived: {
            title: 'Project is archived',
            description: '{{matter}} is archived. The invoice was still approved for it.',
        },
        otherMatterWork: {
            title: 'Work from other projects',
            description: 'This invoice is for {{matter}}, but it also holds work from {{names}}.',
        },
        overheadExpense: {
            title: 'Expense with no project billed',
            description_one: 'This invoice bills {{count}} expense with no project. Expenses with no project are firm overhead and can no longer be added to invoices.',
            description_other: 'This invoice bills {{count}} expenses with no project. Expenses with no project are firm overhead and can no longer be added to invoices.',
        },
    },
    email: {
        attachedGreetingWithReference: 'Invoice {{invoiceNumber}} for project {{reference}} is attached.',
        attachedGreetingWithReferenceProforma: 'Pro forma invoice {{invoiceNumber}} for project {{reference}} is attached.',
    },
    new: {
        selectClientHelper: 'Select a client to choose projects',
        loadProjectsError: "Couldn't load projects with unbilled work",
        projectCount_one: '{{count}} project',
        projectCount_other: '{{count}} projects',
        stepMatter: '2. Project',
        matterGroupAriaLabel: 'Project',
        noMatterOption: 'No project – direct charges only',
        otherMattersNote_one: '{{count}} other project has unbilled work. Invoice it separately.',
        otherMattersNote_other: '{{count}} other projects have unbilled work. Invoice them separately.',
        matterWorkEmpty: 'No approved work on this project yet. The invoice starts empty.',
        matterWorkOverCap: 'This project has {{total}} entries to bill. The invoice starts with the first {{limit}}; add the other {{remaining}} from the draft.',
        matterWorkError: "Couldn't load this project's unbilled work.",
        filterProjectsAriaLabel: 'Filter projects',
        filterProjectsPlaceholder: 'Filter projects...',
        noProjectsMatchFilter: 'No projects match your filter',
        disbursementCount_one: '{{count}} expense',
        disbursementCount_other: '{{count}} expenses',
    },
    dashboard: {
        wipPillLabel: 'Unbilled',
    },
    list: {
        matterLabel: 'Project:',
        sortByProjectReferenceAriaLabel: 'Sort by project reference',
    },
};
